import server from "./server";

export const getAllApi = async (searchParams) => {
  const response = await server().get(`/partners/coupons/?${searchParams}`);

  return response.data;
};

export const addApi = async (data) => {
  const response = await server().post("/partners/coupons", data);

  return response.data;
};

export const getApi = async (id) => {
  const response = await server().get(`/partners/coupons/${id}`);

  return response.data;
};

export const editApi = async ({ id, data }) => {
  const response = await server().put(`/partners/coupons/${id}`, data);

  return response.data;
};

export const deleteApi = async (id) => {
  const response = await server().delete(`/partners/coupons/${id}`);

  return response.data;
};
